import { LOGIN_USER, LOGOUT_USER } from 'context/constants';

export const loginUser = user => ({ type: LOGIN_USER, payload: user });
export const logoutUser = () => {
  localStorage.removeItem('user');
  localStorage.removeItem('userToken');
  localStorage.removeItem('ticket_orders');
  localStorage.removeItem('orders');
  sessionStorage.removeItem('profileTabIndex');
  return { type: LOGOUT_USER };
};
export const redirectUser = redirectlink => ({
  type: 'REDIRECT_USER',
  payload: redirectlink
});
